var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { connect } from 'react-redux';
var Stream = /** @class */ (function (_super) {
    __extends(Stream, _super);
    function Stream() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.componentDidMount = function () {
            _this.player = new window.avvpl.setupPlayer({
                id: "playercontainer"
            });
        };
        return _this;
    }
    Stream.prototype.render = function () {
        return (_jsx("div", __assign({ id: "playercontainer" }, { children: _jsx("video", { children: _jsx("source", { src: this.props.streamUrl }) }) })));
    };
    return Stream;
}(React.Component));
function mapStateToProps(state, props) {
    var betradar = state.betradar;
    return __assign(__assign({}, props), betradar);
}
export default connect(mapStateToProps)(Stream);



// WEBPACK FOOTER //
// ./src/components/grid/event/LiveMatchWidgets/Stream.jsx